import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, tap } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { LanguageUtils } from '../../utils/language.utils';
import { ITicketService, Ticket, TicketResponse, TicketRquest } from './tickets.interface';
import { AuthService } from '../../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class TicketService implements ITicketService {
  constructor(
    private httpClient: HttpClient,
    private readonly authService: AuthService
    ) { }

  getApplicantTickets(limit = 10, offset = 0): Observable<TicketResponse> {
    const from = new Date(new Date().getFullYear(), 0, 1).toISOString();
    const to = new Date().toISOString();
    return this.httpClient.get<TicketResponse>(environment.apiPublicUrl + '/registration/applicant/tickets?applicant=' + this.authService.getCurrentUser().documentNumber + '&from='+ from + '&to=' + to + '&limit=' + limit + '&offset='+ offset + '&language=' + LanguageUtils.getLanguage());
  }
  getApplicantTicket(ticketId: string): Observable<Ticket> {
    return this.httpClient.get<Ticket>(environment.apiPublicUrl + '/registration/applicant/ticket?applicant=' + this.authService.getCurrentUser().documentNumber + '&ticket=' + ticketId + '&language=' + LanguageUtils.getLanguage());
  }
  getExceptionTickets(exceptionId: string): Observable<TicketResponse> {
    throw new Error('Method not implemented.');
  }
  getExceptionTicket(exceptionId: string, ticketId: string): Observable<Ticket> {
    throw new Error('Method not implemented.');
  }

  addApplicantTicket(ticket: TicketRquest): Observable<string> {
    return this.httpClient.post<string>(environment.apiPublicUrl + '/registration/applicant/ticket?applicant=' + this.authService.getCurrentUser().documentNumber + '&language=' + LanguageUtils.getLanguage(), ticket);
  }
}
